module.exports = __webpack_public_path__ + "font/d120c85b6eb0549d60483e2980033c15.ttf";